import type { AnalyticsProvider } from '~analytics/types/analyticsProvider';
import type { RuntimeConfig } from 'nuxt/schema';

declare global {
  interface Window {
    fbq: (operationType: string, eventName: string, eventData?: object) => void;
  }
}

interface PixelAnalytics {
  proxy: {
    fbq: (operationType: string, eventName: string, eventData?: object) => void;
  };
}

export default class MetaPixelProvider implements AnalyticsProvider {
  serviceName: string;
  subscribedEvents: string[];
  config: RuntimeConfig;
  pixelAnalytics?: PixelAnalytics;
  mappedEvents: Record<string, string>

  constructor(
    serviceName: string,
    config: RuntimeConfig,
    subscribedEvents: string[],
  ) {
    this.serviceName = serviceName;
    this.subscribedEvents = subscribedEvents;
    this.config = config;
    this.mappedEvents = {
      'PHOENIX_ACCOUNT_REGISTER_COMPLETED': 'CompleteRegistration',
      'PHOENIX_LEARN_TOPIC_COMPLETED': 'SubmitApplication',
      'unified.content.story.completed': 'Lead',
    };
  }

  async init() {
    if (!this.config.public.scripts.metaPixel?.id) {
      console.warn('Meta Pixel initialized without a Pixel ID');
      return;
    }

    // Load the Meta Pixel SDK - useScript handles CSP nonces automatically
    this.pixelAnalytics = <PixelAnalytics>(<unknown>useScriptMetaPixel({
      id: this.config.public.scripts.metaPixel.id,
    }));
  }

  track(eventName: string, eventData?: object) {
    const event = this.mappedEvents[<keyof typeof this.mappedEvents>eventName]
      ? this.mappedEvents[<keyof typeof this.mappedEvents>eventName]
      : eventName;

    this.pixelAnalytics?.proxy.fbq('track', event ?? eventName, eventData);
  }

  identify() {
    // noop atm
  }

  reset() {
    // noop atm
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  setUserProperties(properties: Record<string, unknown>) {
    // noop atm
  }

  getSubscribedEvents() {
    return this.subscribedEvents;
  }
}
